import React from 'react';
import styled from 'styled-components';
import SingleIconSvg from '../../assets/hotels/single-tick.svg';

const SingleTickIcon = styled(SingleIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '0.6rem'};
  height: ${props => props.height || '0.6rem'};
  margin-left: ${props => props.marginleft};
  margin-right: ${props => props.marginRight};
`;

export default SingleTickIcon;
